module.exports = "/_next/static/images/apple-touch-icon-152-48a5a399e0992476d45d04e63d1fcc81.png";